import { ReactComponent as LogoSVG } from "assets/logo.svg";
import React from "react";
import styled from "styled-components/macro";

const StyledLogo = styled(LogoSVG)`
  width: 64px;
`;

export default function NameLogo({ className }: { className?: string }) {
  return <StyledLogo className={className} />;
}
